(function($) {
    class W4D_Nav {
        constructor() {
            this.init();
        }

        init() {
            this.initSelectors();
            this.initOriginalToggleText();
            this.initSwipeToClose();
            this.initSlinky();
            this.bindEvents();
            this.setupTransitions();
            this.checkInitialHover();
            this.checkActiveCategory();
        }

        initOriginalToggleText() {
            if (this.$megaMenuToggle && this.$megaMenuToggle.length) {
                const $toggleSpan = this.$megaMenuToggle.find('span');
                if ($toggleSpan.length) {
                    this.originalToggleText = $toggleSpan.text();
                }
            } else {
                this.originalToggleText = '';
            }
        }

        checkInitialHover() {
            if (!this.isHeaderType3()) {
                requestAnimationFrame(() => {
                    $('.nav__links-wrapper > .nav__list > .nav__item').each((index, element) => {
                        const $item = $(element);
                        const isHovered = $item.is(':hover');

                        if (isHovered) {
                            this.logExpandedNavHeight($item);
                        }
                    });
                });
            }
        }

        checkActiveCategory() {
            if (this.isHeaderType3()) {
                const activeCategorySlug = this.$megaMenuToggle && this.$megaMenuToggle.length
                    ? this.$megaMenuToggle.attr('data-active-main-category')
                    : null;

                if (activeCategorySlug) {
                    this.highlightActiveCategory(activeCategorySlug);
                }

                $('.nav__links-wrapper > .nav__list > .nav__item').on('click', (e) => {
                    const $clickedItem = $(e.currentTarget);

                    if ($clickedItem.hasClass('nav__item--special')) {
                        return;
                    }

                    const $allItems = $('.nav__links-wrapper > .nav__list > .nav__item');

                    if (!$clickedItem.hasClass('nav__item--submenu-open')) {
                        $allItems.each(function() {
                            $(this).removeClass('nav__item--submenu-open');
                            $(this).find('.nav__link:first').removeClass('nav__link--active');
                        });

                        $clickedItem.addClass('nav__item--submenu-open');
                        $clickedItem.find('.nav__link:first').addClass('nav__link--active');

                        this.animateHeader3SubmenuLinks($clickedItem);
                    }
                });
            }
        }

        initSelectors() {
            this.$header = $('.w4d-header');
            this.$navToggle = $('.nav > .nav__toggle');
            this.$menu = $('[data-slinky-menu]');
            this.$navContainer = $('.nav__container');
            this.$navInner = $('.nav__inner');
            this.$navLinksWrapper = $('.nav__links-wrapper');
            this.$megaMenuToggle = this.$header.find('[data-js-mega-menu-toggle]');
            this.myAccountMobileBtn = $('[data-js-my-account-mobile-trigger]');
            this.myAccountMobileBtnOriginalContent = this.myAccountMobileBtn.length
                ? this.myAccountMobileBtn.html()
                : '';
        }

        isHeaderType3() {
            return this.$header.hasClass('w4d-header--3');
        }

        bindEvents() {
            this.myAccountMobileBtn.on('click', () => this.handleMyAccountMobileBtnClick());
            
            if (this.$navToggle.length) {
                this.$navToggle.on('click', (e) => {
                    e.preventDefault();
                    this.toggleNav();
                });
            }

            let resizeTimeout;
            $(window).on('resize', () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    this.reinitSlinkyOnResize();
                }, 150);
            });

            this.$megaMenuToggle.on('click', () => this.toggleMegaMenu());

            $('.nav__container').on('click', (e) => {
                if (e.target === e.currentTarget) {
                    // For header 3, simulate mega menu toggle instead of regular nav toggle
                    if (this.isHeaderType3()) {
                        this.toggleMegaMenu();
                    } else {
                        this.toggleNav();
                    }
                }
            });

            // Close button inside nav
            $('.nav__header .icon-x-rounded').on('click', (e) => {
                e.preventDefault();
                this.toggleNav();
            });

            if (!this.isHeaderType3()) {
                $('.nav__links-wrapper > .nav__list > .nav__item').on('mouseenter', (e) => {
                    this.logExpandedNavHeight($(e.currentTarget));
                });

                $('.nav__links-wrapper > .nav__list').on('mouseleave', (e) => {
                    this.clearExpandedNavHeight($(e.currentTarget));
                });
            }

            $(document).on('keyup', (e) => {
                if (e.key === 'Escape') {
                    // For header 3, check if mega menu is open
                    if (this.isHeaderType3()) {
                        const $megaMenu = this.$megaMenuToggle.next();
                        if ($megaMenu.hasClass('nav--open')) {
                            this.toggleMegaMenu();
                            return;
                        }
                    }

                    // Regular nav toggle for other headers or when mega menu is not open
                    if (this.$header.hasClass('w4d-header--open')) {
                        this.toggleNav();
                    }
                }
            });

            $(document).on('click', '.nav__item', (e) => {
                const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

                if (mediaQueryXl.matches && this.slinky) {
                    this.scrollNavToTop();
                }
            });
        }

        initSlinky() {
            const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

            if (mediaQueryXl.matches) {
                const slinkyOptions = {
                    title: true,
                    speed: 300,
                    resize: true,
                    activeClass: 'active'
                };

                this.slinky = this.$menu.slinky(slinkyOptions);
                this.addSlinkySpanClasses();
            }
        }

        handleMyAccountMobileBtnClick() {
            if (this.myAccountMobileBtn.html() === this.myAccountMobileBtnOriginalContent) {
                this.myAccountMobileBtn.html('<i class="icon-arrow-left mr-10"></i>Povratak');
            } else {
                this.myAccountMobileBtn.html(this.myAccountMobileBtnOriginalContent);
            }
        }

        addSlinkySpanClasses() {
            const spans = this.$menu[0].querySelectorAll('a > span');

            for (let i = 0; i < spans.length; i++) {
                const span = spans[i];
                const link = span.parentElement;

                if (!link.hasAttribute('data-original-classes')) {
                    link.setAttribute('data-original-classes', link.className);
                }

                const originalClasses = link.getAttribute('data-original-classes').split(' ');

                // Check if we're inside a custom links list (both desktop and mobile)
                const customLinksList = link.closest('.nav__list--topbar-left, .nav__list--topbar-center, .nav__list--topbar-right, .nav__list--topbar-left-mobile, .nav__list--topbar-center-mobile, .nav__list--topbar-right-mobile');
                const isInCustomLinks = customLinksList !== null;

                const hasNext = originalClasses.includes('next');

                // Start with original classes, filter out 'next' and mobile variants
                let filteredClasses = originalClasses.filter(cls =>
                    cls !== 'next' &&
                    !cls.includes('-mobile')
                );

                // Check for special classes from original classes
                const hasSpecialClass = originalClasses.some(cls => cls.includes('nav__link--special'));

                if (hasSpecialClass) {
                    // Convert nav__link--special to nav__link--special-mobile and remove nav__link--mobile
                    filteredClasses = filteredClasses.map(cls => {
                        if (cls.includes('nav__link--special')) {
                            return cls + '-mobile';
                        }
                        return cls;
                    }).filter(cls => cls !== 'nav__link--mobile');
                } else if (isInCustomLinks) {
                    // For topbar links: remove nav__link--topbar and don't add nav__link--mobile
                    filteredClasses = filteredClasses.filter(cls => cls !== 'nav__link--topbar');
                } else {
                    // For regular links: add nav__link--mobile
                    filteredClasses.push('nav__link--mobile');
                }

                if (hasNext) {
                    filteredClasses.push('next');
                }

                link.className = filteredClasses.join(' ');
                span.className = '';

                if (hasSpecialClass) {
                    span.className = 'nav__text nav__text--special-mobile';
                } else if (isInCustomLinks) {
                    span.className = 'nav__text nav__text--topbar-mobile';

                    // Add nav__link--topbar-mobile only if not already present
                    if (!link.className.includes('nav__link--topbar-mobile')) {
                        link.className += ' nav__link--topbar-mobile';
                    }

                    // Remove nav__list--topbar from the current UL if it contains topbar-mobile links
                    const currentUL = link.closest('.nav__list');
                    if (currentUL && currentUL.classList.contains('nav__list--topbar')) {
                        currentUL.classList.remove('nav__list--topbar');
                    }
                } else {
                    let level = '1';

                    for (let j = 0; j < originalClasses.length; j++) {
                        const cls = originalClasses[j];
                        const levelIndex = cls.indexOf('--l');
                        if (levelIndex !== -1) {
                            level = cls.substring(levelIndex + 3);
                            break;
                        }
                    }

                    span.className = `nav__text nav__text--l${level}`;
                }
            }
        }

        restoreOriginalClasses() {
            const links = this.$menu[0].querySelectorAll('a[data-original-classes]');

            for (let i = 0; i < links.length; i++) {
                const link = links[i];
                const originalClasses = link.getAttribute('data-original-classes');

                // Restore the original classes exactly as they were
                link.className = originalClasses;

                // Remove the 'next' class if it exists (added by Slinky)
                link.classList.remove('next');

                // Find the span inside this link and clear its classes
                const span = link.querySelector('span');
                if (span) {
                    span.className = '';
                }
            }
        }

        setupTransitions() {
            // This prevents unwanted animations on initial load
            setTimeout(() => {
                this.$navContainer.addClass('nav__container--transitions-enabled');
            }, 100);
        }

        reinitSlinkyOnResize() {
            const mediaQueryXl = window.matchMedia('(max-width: 1400px)');

            // Temporarily disable transitions during resize
            this.$navContainer.removeClass('nav__container--transitions-enabled');

            if (mediaQueryXl.matches && !this.slinky) {
                const slinkyOptions = {
                    title: true,
                    speed: 300,
                    resize: true,
                    activeClass: 'active'
                };

                this.slinky = this.$menu.slinky(slinkyOptions);

                this.addSlinkySpanClasses();
                this.closeNav();
            }

            else if (!mediaQueryXl.matches && this.slinky) {
                if (typeof this.slinky.destroy === 'function') {
                    this.slinky.destroy();
                    this.slinky = null;
                }

                // Restore original classes when going above XL breakpoint
                this.restoreOriginalClasses();
                this.closeNav();
            }

            // Re-enable transitions after a short delay
            setTimeout(() => {
                this.$navContainer.addClass('nav__container--transitions-enabled');
            }, 50);
        }

        highlightActiveCategory(categorySlug) {
            const targetPattern = `/${categorySlug}/`;

            $('.nav__link').each(function() {
                const href = $(this).attr('href');
                if (href && href.endsWith(targetPattern)) {
                    $(this).addClass('nav__link--active');
                    return false;
                }
            });
        }

        scrollNavToTop() {
            if (this.$navLinksWrapper.length) {
                this.$navLinksWrapper.animate({
                    scrollTop: 0
                }, 300); // 300ms animation duration
            }
        }

        toggleMegaMenu() {
            if(this.$megaMenuToggle.is(':hidden')) return;

            const $megaMenu = this.$megaMenuToggle.next();
            const $toggleSpan = this.$megaMenuToggle.find('span');

            $megaMenu.toggleClass('nav--open');
            this.$megaMenuToggle.toggleClass('nav__toggle--open');

            if ($megaMenu.hasClass('nav--open')) {
                $toggleSpan.text('Zatvori kategorije');

                // Initialize first item when mega menu opens (if not already set)
                const $activeItem = $('.nav__links-wrapper > .nav__list > .nav__item.nav__item--submenu-open');
                if (!$activeItem.length) {
                    // No active item found, set the first one
                    const $firstNavItem = $('.nav__links-wrapper > .nav__list > .nav__item:first-child');
                    if ($firstNavItem.length) {
                        $firstNavItem.addClass('nav__item--submenu-open');
                        $firstNavItem.find('.nav__link:first').addClass('nav__link--active');
                    }
                }

                const $currentActive = $('.nav__links-wrapper > .nav__list > .nav__item.nav__item--submenu-open');
                if ($currentActive.length) {
                    this.animateHeader3SubmenuLinks($currentActive);
                }
            } else {
                $toggleSpan.text(this.originalToggleText);
            }
        }

        toggleNav() {
            this.$header.toggleClass('w4d-header--open');
            this.$navToggle.toggleClass('nav__toggle--open');

            if (this.myAccountMobileBtn.html() !== this.myAccountMobileBtnOriginalContent) {
                this.myAccountMobileBtn.html(this.myAccountMobileBtnOriginalContent);
            }
        }

        closeNav() {
            this.$header.removeClass('w4d-header--open');
            this.$navToggle.removeClass('nav__toggle--open');

            if (this.$navInner && this.$navInner[0]) {
                this.$navInner[0].style.transform = '';
                this.$navInner[0].style.transition = '';
            }

            this.myAccountMobileBtn.html(this.myAccountMobileBtnOriginalContent);
        }

        logExpandedNavHeight($hoveredItem) {
            // Remove :visible selector since we want to measure hidden elements too
            const $expandedNav = $hoveredItem.find('.nav__list--l2');

            $hoveredItem.siblings('.nav__item--submenu-open')
                .removeClass('nav__item--submenu-open')
                .find('.nav__link--animate-in')
                .removeClass('nav__link--animate-in');

            if ($expandedNav.length) {
                const height = $expandedNav.outerHeight();
                $hoveredItem.parent().css('--submenu-height', `${height}px`);

                // Add animation class when submenu opens
                $hoveredItem.addClass('nav__item--submenu-open');

                // Trigger animations for individual links
                this.animateSubmenuLinks($expandedNav);
            } else {
                // Clear the submenu height when there's no submenu
                $hoveredItem.parent().css('--submenu-height', '');
            }
        }

        clearExpandedNavHeight($navContainer) {
            $navContainer.css('--submenu-height', '');

            // Remove animation classes when submenu closes
            $navContainer.find('.nav__item').removeClass('nav__item--submenu-open');
            $navContainer.find('.nav__link').removeClass('nav__link--animate-in');
        }

        animateSubmenuLinks($submenu) {
            const $links = $submenu.find('> .nav__item .nav__link');
            const $linksLevel3 = $submenu.find('.nav__list--l3 .nav__link');

            // Reset any existing animations
            $links.removeClass('nav__link--animate-in');
            $linksLevel3.removeClass('nav__link--animate-in');

            // Add animation class with staggered delay
            $links.each((index, link) => {
                setTimeout(() => {
                    $(link).addClass('nav__link--animate-in');
                }, index * 6);
            });
        }

        animateHeader3SubmenuLinks($activeItem) {
            // Clear all existing animations first
            $('.nav__link').removeClass('nav__link--animate-in');

            // Only animate the submenu of the active item
            const $submenu = $activeItem.find('.nav__list--l2');
            if ($submenu.length) {
                const $links = $submenu.find('> .nav__item .nav__link');
                const $linksLevel3 = $submenu.find('.nav__list--l3 .nav__link');

                // Add animation class with staggered delay
                $links.each((index, link) => {
                    setTimeout(() => {
                        $(link).addClass('nav__link--animate-in');
                    }, index * 6);
                });
            }
        }

        initSwipeToClose() {
            this.swipe = {
                startX: 0,
                startY: 0,
                currentX: 0,
                startTime: 0,
                isActive: false,
                isHorizontalSwipe: false,
                threshold: 50,
                closeThreshold: 0.4,
                durationThreshold: 1000
            };

            if ('ontouchstart' in window) {
                const navInnerElement = this.$navInner[0];

                navInnerElement.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
                navInnerElement.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
                navInnerElement.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
                navInnerElement.addEventListener('touchcancel', this.handleTouchEnd.bind(this), { passive: true });
            }
        }

        handleTouchStart(e) {
            if (!this.$header.hasClass('w4d-header--open')) return;

            const touch = e.touches[0];
            this.swipe = {
                ...this.swipe,
                startX: touch.clientX,
                startY: touch.clientY,
                currentX: touch.clientX,
                startTime: Date.now(),
                isActive: true,
                isHorizontalSwipe: false
            };

            // Clear any existing transforms and transitions
            this.$navInner[0].style.transition = '';
            this.$navInner.addClass('nav__inner--swiping');
        }

        handleTouchMove(e) {
            if (!this.swipe.isActive || !this.$header.hasClass('w4d-header--open')) return;

            const touch = e.touches[0];
            const deltaX = touch.clientX - this.swipe.startX;
            const deltaY = touch.clientY - this.swipe.startY;
            const currentTime = Date.now();
            const duration = currentTime - this.swipe.startTime;

            // Check duration threshold
            if (duration > this.swipe.durationThreshold) {
                this.endSwipe(true); // Force bounce back
                return;
            }

            // Determine swipe direction
            if (!this.swipe.isHorizontalSwipe && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
                this.swipe.isHorizontalSwipe = true;
            }

            // Only handle rightward horizontal swipes
            if (this.swipe.isHorizontalSwipe && deltaX > 0) {
                e.preventDefault();
                this.swipe.currentX = touch.clientX;

                const navWidth = this.$navInner.outerWidth();
                const swipePercentage = deltaX / navWidth;

                // Immediate close when threshold is reached
                if (swipePercentage >= this.swipe.closeThreshold) {
                    this.endSwipe(false); // Trigger close
                    return;
                }

                // Update position smoothly
                const swipeDistance = Math.max(0, deltaX);
                this.$navInner[0].style.transform = `translateX(${swipeDistance}px)`;
            }
        }

        handleTouchEnd(e) {
            if (!this.swipe.isActive) return;

            const deltaX = this.swipe.currentX - this.swipe.startX;
            const duration = Date.now() - this.swipe.startTime;
            const navWidth = this.$navInner.outerWidth();
            const swipePercentage = deltaX / navWidth;
            const velocity = this.calculateVelocity(deltaX, duration);

            // Determine action based on swipe
            const shouldClose = this.swipe.isHorizontalSwipe &&
                deltaX > this.swipe.threshold &&
                duration <= this.swipe.durationThreshold &&
                (swipePercentage >= this.swipe.closeThreshold || velocity > 0.8);

            this.endSwipe(!shouldClose);
        }

        endSwipe(shouldBounceBack) {
            if (!this.swipe.isActive) return;

            this.swipe.isActive = false;
            this.$navInner.removeClass('nav__inner--swiping');

            if (shouldBounceBack) {
                this.animateNavBounceBack();
            } else {
                this.animateNavClose();
            }

            this.resetSwipeData();
        }

        calculateVelocity(distance, duration) {
            if (duration <= 0) return 0;
            const navWidth = this.$navInner.outerWidth();
            const normalizedDistance = Math.abs(distance / navWidth);
            return normalizedDistance / (duration / 1000);
        }

        animateNavClose() {
            const navWidth = this.$navInner.outerWidth();
            this.$navInner[0].style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            this.$navInner[0].style.transform = `translateX(${navWidth}px)`;

            setTimeout(() => {
                this.closeNav();
            }, 300);
        }

        animateNavBounceBack() {
            this.$navInner[0].style.transition = 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)';
            this.$navInner[0].style.transform = 'translateX(0)';

            setTimeout(() => {
                this.$navInner[0].style.transition = '';
            }, 400);
        }

        resetSwipeData() {
            this.swipe.isActive = false;
            this.swipe.isHorizontalSwipe = false;
            this.swipe.startX = 0;
            this.swipe.currentX = 0;
            this.swipe.startTime = 0;
        }
    }

    $(document).ready(() => new W4D_Nav());
})(jQuery);